import { DocumentTemplatePermissions } from './documentTemplate.permissions';
import { DocumentTemplateRoles } from './documentTemplate.roles';

export const documentTemplateMappings = {
  [DocumentTemplatePermissions.GET_DOCUMENT_TEMPLATES]: [
    DocumentTemplateRoles.VIEWER,
  ],
  [DocumentTemplatePermissions.CREATE_DOCUMENT_TEMPLATE]: [
    DocumentTemplateRoles.MANAGER,
  ],
  [DocumentTemplatePermissions.UPDATE_DOCUMENT_TEMPLATE]: [
    DocumentTemplateRoles.MANAGER,
  ],
  [DocumentTemplatePermissions.ARCHIVE_DOCUMENT_TEMPLATE]: [
    DocumentTemplateRoles.MANAGER,
  ],
};
